import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Gallery from './pages/Gallery/Gallery';
import Shop from './pages/Shop/Shop';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

function App() {
  return (

   <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/AboutMe" element={<About />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Shop" element={<Shop />} />
      </Routes>
   </BrowserRouter>
 );
}

export default App;
